import { useQuery } from "@tanstack/react-query";
import { qk } from "#/lib/queryKeys";
import { getArticleReviewById, ArticleReview } from "#/services/articleReviews";

export function useArticleReviewDetail(id?: string) {
  return useQuery<ArticleReview>({
    queryKey: id ? qk.articleReviewDetail(id) : qk.articleReviews(),
    queryFn: ({ signal }) => {
      if (!id) {
        return Promise.reject(new Error("Review id is required"));
      }
      return getArticleReviewById(id, { signal });
    },
    enabled: Boolean(id),
    staleTime: 30_000,
  });
}

export default useArticleReviewDetail;
